import url from './url';



export default url(({ notificationId = ':notificationId' }) => `/push-notifications/${notificationId}/edit`);
